import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/ton_app.jpg")